/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import React from 'react';
import { DataShareSettings } from '../../components/data-share/DataShareSettings';
import { useParams } from 'react-router-dom';

interface Props {
}

export const DataShareRoute = (props: Props) => {

  const { shareId, initiativeId } = useParams<{ initiativeId: string, shareId?: string }>()

  return <DataShareSettings initiativeId={initiativeId} shareId={shareId}/>
}
